import React, { Component } from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import { Grid, Box, Button, TextField, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Paper, RadioGroup, Radio, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import environment from '../../environment';

const getGameByIdQuery = graphql`
  query LeaderboardDetailsGetGameByIdQuery(
    $id: ID!
  ){
    findGameById(id: $id) {
      data {
        name
        game_quarter_label
        game_type_id
        quarters {
            quarter_name
        }
      }
    }
  }
`;

class LeaderboardDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            open: false,
            selectedSegment: 0,
        }
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.selectChapter = this.selectChapter.bind(this);
        this.setName = this.setName.bind(this);
        this.setSegmentNum = this.setSegmentNum.bind(this);
        this.setLink = this.setLink.bind(this);
        this.setNumberWinners = this.setNumberWinners.bind(this);
    }

    handleClose(){
        this.setState({open: false});
    }

    handleOpen(i){
        this.setState({open: true, selectedSegment: i+1});
    }

    selectChapter(e, i){
        const c = parseInt(e.target.value);
        const event_settings = this.props.state.values.event_settings;
        if(i >= 0){ // Chapter 1, 2, 3
            if(event_settings[this.state.selectedSegment - 1][`game${i+1}_quarter`] == c){
                this.props.handleChange({
                    target: {
                        name: "segments",
                        index: this.state.selectedSegment - 1,
                        value: null,
                        type: `game${i+1}_quarter`
                    }
                })
            } else {
                this.props.handleChange({
                    target: {
                        name: "segments",
                        index: this.state.selectedSegment - 1,
                        value: c,
                        type: `game${i+1}_quarter`
                    }
                })
            }
        }
        if (c == -1) { // Cumulative
            this.props.handleChange({
                target: {
                    name: "segments",
                    index: this.state.selectedSegment - 1,
                    value: true,
                    type: "cumulative_leaderboard",
                }
            })
        } else {
            this.props.handleChange({
                target: {
                    name: "segments",
                    index: this.state.selectedSegment - 1,
                    value: false,
                    type: "cumulative_leaderboard",
                }
            })
        }
    }

    setName(e, i){
        const name = e.target.value;
        this.props.handleChange({
            target: {
                name: "segments",
                index: i,
                value: name,
                type: "name",
            }
        })
    }

    setNumberWinners(e, i){
        const number = e.target.value;
        this.props.handleChange({
            target: {
                name: "segments",
                index: i,
                value: parseInt(number),
                type: "number_of_winners",
            }
        })
    }

    setSegmentNum(e){
        let value = e.target.value;
        if(value == " ") value = null;
        this.props.handleChange({
            target: {
                name: "segmentNum",
                value: parseInt(value),
            }
        })
    }

    setLink(e){
        let link = e.target.value;
        this.props.handleChange({
            target: {
                name: "leaderboard_link",
                value: link,
            }
        })
    }

    render(){
        const { classes, handlePrevious, handleNext, state } = this.props;
        const { open, selectedSegment } = this.state;
        const { values, segmentNum } = state;
        const { event_settings } = values;
        return (
            <>
            <div className={classes.fieldsContainer}>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12}>
                        <label className={classes.lbLabel}>
                            Leaderboard
                        </label>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid container>
                            <Grid item md={8} xs={12}>
                                <Select
                                fullWidth
                                value={segmentNum ? segmentNum : " "}
                                onChange={(e) => this.setSegmentNum(e)}
                                >
                                    <MenuItem value=" ">
                                        Number of Leaderboard Segments
                                    </MenuItem>
                                {
                                Array(20).fill(0).map((_, i) => (
                                    <MenuItem value={i+1} key={i}>
                                        {i+1}
                                    </MenuItem>
                                ))
                                }
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                    {/* EMPTY GRID for LAYOUT */}
                    </Grid>
                    {
                    segmentNum ?
                    Array(segmentNum).fill(0).map((_, i) => {
                        let val = 0;
                        if(event_settings[i].game1_quarter != null) val += 1;
                        if(event_settings[i].game2_quarter != null) val += 1;
                        if(event_settings[i].game3_quarter != null) val += 1;
                        return (
                            [
                            <Grid item md={6} xs={6} key={`g${i}`}>
                                <Grid container>
                                    <Grid item xs={8}>
                                        <TextField
                                            fullWidth
                                            variant="standard"
                                            className={classes.inputField}
                                            placeholder={`Segment #${i+1} Name`}
                                            value={event_settings[i] && event_settings[i].name ? event_settings[i].name : ""}
                                            onChange={(e) => this.setName(e, i)}
                                        />
                                    </Grid>
                                    <Grid item xs={4} style={{textAlign: 'center'}}>
                                        <ArrowRightAltIcon className={classes.arrowIcon} />
                                    </Grid>
                                </Grid>
                            </Grid>,
                            <Grid item md={6} xs={6} key={i}>
                                <Grid container>
                                    <Grid item xs={8}>
                                        <Select
                                        fullWidth
                                        value={val}
                                        onClick={() => this.handleOpen(i)}
                                        inputProps={{readOnly: true}}
                                        >
                                            <MenuItem value={0}>
                                                Add Chapters to Segment {i+1}
                                            </MenuItem>
                                            <MenuItem value={1}>
                                                One Chapter Added
                                            </MenuItem>
                                            <MenuItem value={2}>
                                                Two Chapters Added
                                            </MenuItem>
                                            <MenuItem value={3}>
                                                Three Chapters Added
                                            </MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            variant="standard"
                                            type="number"
                                            InputProps={{ inputProps: { min: 1 } }}
                                            className={classes.winnerField}
                                            placeholder='Number of Winners'
                                            value={event_settings[i] && event_settings[i].number_of_winners ? event_settings[i].number_of_winners : null}
                                            onChange={(e) => this.setNumberWinners(e, i)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            ]
                    )}) : <></>
                    }
                </Grid>
                <Dialog open={open} onClose={this.handleClose} classes={{paper: classes.dialogPaper}}>
                    <DialogContent>
                        <Paper elevation={0}>
                        <span style={{fontSize: '0.9em'}}>Select which chapters of point-based games you'd like to add to your leaderboard segment.</span>
                        <br/>
                        <br/>
                        {
                            [values.game1_id, values.game2_id, values.game3_id].map((game_id, i) => (
                                game_id &&
                                <QueryRenderer
                                key={i}
                                environment={environment}
                                query={getGameByIdQuery}
                                variables={{
                                    id: game_id,
                                }}
                                render={({error, props}) => {
                                    if(props && props.findGameById.data && props.findGameById.data.game_type_id != '1' && props.findGameById.data.game_type_id != '6'){
                                        const data = props.findGameById.data;
                                        let current = " ";
                                        if(event_settings[selectedSegment-1]){
                                            current = event_settings[selectedSegment-1][`game${i+1}_quarter`] ? event_settings[selectedSegment-1][`game${i+1}_quarter`] : " ";
                                        }
                                        let chapter_names = [];
                                        if(data.quarters && data.quarters.length > 0){
                                            data.quarters.map(q => {
                                                chapter_names.push(q.quarter_name);
                                            })
                                        } else if(data.game_quarter_label && data.game_quarter_label.length > 0){
                                            chapter_names = data.game_quarter_label.split(",");
                                        }
                                        return ([
                                            <label className={classes.lbLabel} key={`label${i}`}>
                                                {data.name}
                                            </label>,
                                            <RadioGroup value={current} key={`radio${i}`}>
                                            {
                                                chapter_names.map((chapter, ind) => {
                                                return (
                                                    <FormControlLabel
                                                        className={classes.radioLabel} key={ind}
                                                        value={ind+1}
                                                        control={<Radio onClick={(e) => this.selectChapter(e,i)} />}
                                                        label={chapter}
                                                    />
                                                )
                                                })
                                            }
                                            {
                                                chapter_names.length > 1 &&
                                                <FormControlLabel
                                                    className={classes.radioLabel}
                                                    value={-1}
                                                    control={<Radio onClick={(e) => this.selectChapter(e,i)} />}
                                                    label="All Chapters"
                                                />
                                            }
                                            </RadioGroup>
                                        ])
                                    }
                                }}
                                />
                            ))
                        }
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} className={classes.addButton} variant="contained" color="default">
                            Add Chapters
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <Grid container className={classes.buttonContainer} spacing={4}>
                <Button
                className={classes.previousButton}
                onClick={() => handlePrevious('leaderboard_details')}
                variant="contained"
                color="default"
                >
                Previous
                </Button>
                <Button
                className={classes.nextButton}
                onClick={() => handleNext('leaderboard_details')}
                variant="contained"
                color="primary"
                >
                Next
                </Button>
            </Grid>
            </>
        )
    }
}

export default withStyles(useStyles)(LeaderboardDetails);
